import _taggedTemplateLiteral from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from "styled-components";
import { colors, size, typography } from "../../../shared/constants";
var OrderDisclaimer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 12px 0;\n  line-height: 1.5;\n  text-align: left;\n  font-weight: ", ";\n  letter-spacing: 0.27px;\n  color: ", ";\n  padding: ", " ", "px;\n  background-color: ", ";\n"])), typography.weight.book, colors.gray5, function (o) {
  return o.highlighted ? "18px" : "0";
}, size.md, function (o) {
  return o.highlighted ? colors.green2 : "none";
});
export { OrderDisclaimer };